import { GetUserLogs } from '@/apis/user'

import columns from './tableConfig'
import { searchItems, logTypes } from './searchFormConfig'
let searchCache = {}

export default {
  name: 'User.UserLog',
  components: {},
  data () {
    return {
      searchItems,
      logTypes,
      searching: false,

      columns,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {

    this.$nextTick(() => {
      this.$refs.searchForm.handlerSearch()
    })
  },
  methods: {
    async getUserLogs(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData

        const { userName, operateType, dateTimeRange } = searchData
        let operateAtFrom, operateAtTo
        if (dateTimeRange && dateTimeRange.length) {
          operateAtFrom = dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss')
          operateAtTo = dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss')
        }

        const { collection, pageInfo } = await GetUserLogs({
          userName, operateType, operateAtFrom, operateAtTo,
          page, perPage: this.pagination.pageSize
        })

        this.data = collection.map(item => Object.assign(item, { key: item.id }))

        this.pagination.current = page
        this.pagination.total = pageInfo.total
      } catch (error) {}
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.getUserLogs(current)
    }
  }
}
